export default __webpack_public_path__ + "static/media/logo.634ba9c5.svg";